//Dependencies
import React from 'react';
import { Affix } from 'antd';
import { InfoFilledIcon, LayerFilledIcon } from '../../../icons/icons';
import { useDispatch } from 'react-redux';

/* SIDEMENU */
const Sidemenu01 = (props) =>
{
  const { height, layers, visible } = props; 
  const dispatch = useDispatch();

  if(!visible) return null;

  const clickInfo = () =>
  {
    dispatch({type: 'SET_MODAL_01', modal01 : true});
  };
  
  return(
    <Affix 
      style = {{ position: "fixed", bottom: height, right: 10, zIndex : 1000}}
    >
      <div>        
        <div 
          className = "flex items-center justify-center text-white p-3 text-center mb-2 md:mb-4 lg:mb-5 lg:w-16 lg:h-16 w-12 h-12 shadow-lg rounded-full cursor-pointer bg-gray-800 hover:bg-sky-600"
          onClick   = {() => dispatch({type: 'SET_LAYERS', layers : !layers})}
        >
          <LayerFilledIcon className = ' flex text-xl lg:text-2xl flex cursor-pointer '/>
        </div>
       
        <div 
          className = "flex items-center justify-center text-white p-3 text-center mb-2 md:mb-4 lg:mb-5 lg:w-16 lg:h-16 w-12 h-12 shadow-lg rounded-full cursor-pointer bg-gray-800 hover:bg-sky-600"
          onClick   = {() => clickInfo()}
        >
          <InfoFilledIcon className = ' text-xl lg:text-2xl flex cursor-pointer '/>
        </div>
      </div>
    </Affix>
  );
}

export default Sidemenu01;